import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import { configureStore } from './store/configure-store';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';

const rootDOM = document.getElementById('root') as HTMLElement;

ReactDOM.render((
    <Provider store={configureStore()}>
        <Router>
            <App />
        </Router>
    </Provider>
), rootDOM);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
